import gql from 'graphql-tag';

const REFUSE_REQUEST = gql`
    mutation refuseRequest ($idOrder: String!, $ean: String!, $statusItem: String!) {
        refuseRequest (idOrder: $idOrder, ean: $ean, statusItem: $statusItem) {
            message,
            status,
            data
        }
    }
`;

export default REFUSE_REQUEST;
